import { ProductType } from "@obg/ngx.core";

import { KebabCasePipe } from "./pipes/kebab-case.pipe";
import { TakePipe } from "./pipes/take.pipe";

export const UTIL_PIPES: (typeof KebabCasePipe | typeof TakePipe)[] = [KebabCasePipe, TakePipe];

const gameLauncher = "game-launcher";

export const GAMING_GAME_LAUNCHERS = [
	`${ProductType.Casino}.${gameLauncher}`,
	`${ProductType.Jackpots}.${gameLauncher}`,
	`${ProductType.Slots}.${gameLauncher}`,
	`${ProductType.LiveCasino}.${gameLauncher}`,
	`${ProductType.Keno}.${gameLauncher}`,
	`${ProductType.MiniGames}.${gameLauncher}`,
	`${ProductType.Poker}.${gameLauncher}`,
	`${ProductType.TableGames}.${gameLauncher}`,
	`${ProductType.TurkishPoker}.${gameLauncher}`,
];
export const SB_MFE_FLAG_KEY = "sb_mfe";
